import { type ComponentPropsWithoutRef } from 'react';

import { createPortal } from 'react-dom';

import { AnimatedLogo } from '../AnimatedLogo';

export interface SplashScreenProps extends Omit<ComponentPropsWithoutRef<'div'>, 'children'> {
  /** Render in a React Portal (recommended for proper z-index stacking) */
  portal?: boolean;
}

/**
 * SplashScreen - Full-screen loading overlay with animated logo
 * Used during initial app loading and authentication checks
 */
export function SplashScreen({ portal = true, className = '', ...other }: SplashScreenProps) {
  const content = (
    <div className="overflow-hidden">
      <div
        className={`fixed inset-0 z-splash flex items-center justify-center bg-tkf-surface-page ${className}`}
        {...other}
      >
        <AnimatedLogo size="md" />
      </div>
    </div>
  );

  if (portal && typeof document !== 'undefined') {
    return createPortal(content, document.body);
  }

  return content;
}
